//GET_LANGUAGE_TRANSLATORS
export const GET_LANGUAGE_TRANSLATORS_REQUEST =
  "GET_LANGUAGE_TRANSLATORS_REQUEST";
export const GET_LANGUAGE_TRANSLATORS_SUCCESS =
  "GET_LANGUAGE_TRANSLATORS_SUCCESS";
export const GET_LANGUAGE_TRANSLATORS_FAIL = "GET_LANGUAGE_TRANSLATORS_FAIL";
